module.exports = __webpack_public_path__ + "ddfb4b264ddd2e9e87c4c2b8504c997e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/tie-s.png
// module id = 1405
// module chunks = 0